import { createSelector } from 'reselect'

const getAdvertisements = state => state.advertisements

export const getAdvertisementsList = createSelector(
  getAdvertisements,
  advertisements => Object.values(advertisements),
)
